<template>
<div>

<div class="columns is-gapless">
    <div class="column is-4" style="border-right: 1px solid #647882;">
        <div class="field">
        <div class="control">
            <input disabled=false v-model="student_note" @change="mod_note()" class="input has-text-weight-bold has-text-centered is-size-6 has-background-grey-lighter" type="text" placeholder="total">
        </div>
        </div>        
    </div>

<div class="column is-8">
    <div class="control">
    <div class="select is-fullwidth">
        <select :disabled="enabled" @change="mod_remark()" :class="return_style_remark()" v-model="student_remark">
        <option></option>
        <option>EC</option>
        <option>EQ</option>
        <option>IN</option>
        </select>
    </div>
    </div>
</div>
 

</div>




</div>
</template>

<script>
import axios from 'axios';

export default {
        // props: [ 'note', 'remark', 'id', 'stud_index', 'enabled'],
        props: [ 'note', 'remark', 'cs_id', 'enabled'],
        components: {  },

        data() {
            return {
                 student_note:this.note,
                 student_remark:this.remark,
                 student_id:this.id,
                 isLoading:false,
            }
        },

methods : {

return_style_remark:function() {
    if (this.student_remark == 'EC')
    {return "has-text-weight-bold has-text-danger"}
    else {return "has-text-weight-bold has-text-dark"}
},

mod_remark:function() {
    this.$emit('emit_remark_update', this.cs_id, this.student_remark)
},

    mod_note:function() {
        //alert(this.id)

//var sql = `UPDATE MyMEQ_PROF_NOTES SET note_NOTE = ` + this.student_note + ` WHERE note_ID = ` + this.id
//axios.get(this.$url+'/student_insert?query=' + sql)

    }, // END MOD_NOTE

}, // END METHODS


}
</script>